import { useState } from 'react';
import Icon from 'components/Icon';
import Seo from 'components/Seo';
import ToolSeoContent from 'components/ToolSeoContent';

// Case Converter — transform text between cases. Runs fully in the browser.
export default function CaseConverter() {
  const [text, setText]     = useState('');
  const [copied, setCopied] = useState(false);

  const toTitle = s => s.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
  const toSentence = s => s.toLowerCase().replace(/(^\s*\w|[.!?]\s*\w)/g, c => c.toUpperCase());
  const toToggle = s => s.split('').map(c => c === c.toUpperCase() ? c.toLowerCase() : c.toUpperCase()).join('');

  const CASES = [
    { label:'UPPERCASE',     fn: s => s.toUpperCase() },
    { label:'lowercase',     fn: s => s.toLowerCase() },
    { label:'Title Case',    fn: toTitle },
    { label:'Sentence case', fn: toSentence },
    { label:'tOGGLE cASE',   fn: toToggle },
  ];

  const apply = fn => setText(t => fn(t));

  const copy = () => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const clear = () => setText('');

  const words = text.trim() ? text.trim().split(/\s+/).length : 0;
  const chars = text.length;

  return (
    <>
    <Seo title="Case Converter — UPPERCASE, lowercase" description="Convert text to UPPERCASE, lowercase, Title Case and more. Free, instant." path="/tools/text/case-converter" />
    <div className="tool-pg">
      <div className="container" style={{ maxWidth: 760 }}>
        <div className="tool-hdr">
          <div className="tool-hdr-row">
            <div className="tool-hdr-icon cat-text"><Icon name="type" size={24} /></div>
            <div>
              <h1>Case Converter</h1>
              <p>Change text to UPPERCASE, lowercase, Title Case, and more. Instant and private.</p>
            </div>
          </div>
        </div>

        <div className="tool-box">
          <textarea
            className="form-control"
            placeholder="Type or paste your text here..."
            value={text}
            onChange={e => setText(e.target.value)}
            style={{ minHeight:200, resize:'vertical', fontSize:15, lineHeight:1.6, marginBottom:14 }}
          />

          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16, fontSize:13, color:'var(--slate-400)' }}>
            <span>{words} words · {chars} characters</span>
            <div style={{ display:'flex', gap:8 }}>
              <button className="btn btn-secondary btn-sm" onClick={copy}>
                <Icon name={copied ? 'check' : 'copy'} size={14} />{copied ? 'Copied!' : 'Copy'}
              </button>
              <button className="btn btn-secondary btn-sm" onClick={clear}>
                <Icon name="trash" size={14} />Clear
              </button>
            </div>
          </div>

          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(130px,1fr))', gap:10 }}>
            {CASES.map(c => (
              <button key={c.label} className="btn btn-outline" onClick={() => apply(c.fn)} disabled={!text} style={{ justifyContent:'center' }}>
                {c.label}
              </button>
            ))}
          </div>
        </div>

        <div className="tool-info">
          <Icon name="info" size={16} />
          <p>Title Case capitalizes every word. Sentence case capitalizes the first letter of each sentence. Your text stays in your browser — nothing is uploaded.</p>
        </div>
        <ToolSeoContent tool="case-converter" />
      </div>
    </div>
  </>
  );
}
